import React from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useRoutesProvider } from '../../../../../providers/provider-hooks';
import { Progress } from '../../../../../components/ui/progress';
import { cn } from '../../../../../shared/utils';

export interface LessonTopBarProps {
  current: number;
  total: number;
  /** Implicit: navighează la lista de lecții. Nu folosi niciodată navigate('/') — bug 2.14. */
  onExit?: () => void;
  exitDisabled?: boolean;
}

const MAX_SEGMENTS = 12;

export const LessonTopBar: React.FC<LessonTopBarProps> = ({ current, total, onExit, exitDisabled = false }) => {
  const navigate = useNavigate();
  const { PATHS, PAGES } = useRoutesProvider();
  const handleExit = onExit ?? (() => navigate(PATHS[PAGES.LESSON_QUIZ_LISTING]));
  const useSegments = total > 0 && total <= MAX_SEGMENTS;
  const percentage = total > 0 ? (current / total) * 100 : 0;

  return (
    <div className="lesson-top-bar safe-area-top">
      <button
        type="button"
        onClick={handleExit}
        disabled={exitDisabled}
        aria-label="Ieși din lecție"
        className="touch-target flex items-center justify-center rounded-full text-foreground hover:bg-muted disabled:opacity-50"
      >
        <X className="w-6 h-6" />
      </button>

      {/* M6 (final-review.md): grupul de progres nu mai include butonul ✕ — doar segmentele/bara
          si contorul, care e singurul anuntat la schimbarea slide-ului (aria-live). */}
      <div className="flex items-center gap-3 flex-1" role="group" aria-label="Progres lecție">
        {useSegments ? (
          <div className="lesson-progress-segments" aria-hidden="true">
            {Array.from({ length: total }, (_, i) => (
              <span
                key={i}
                className={cn('lesson-progress-segment', i < current && 'lesson-progress-segment-done')}
              />
            ))}
          </div>
        ) : (
          <Progress value={percentage} className="lesson-progress-bar flex-1" />
        )}

        <span className="text-sm font-semibold tabular-nums whitespace-nowrap pr-1" aria-live="polite">
          {current}/{total}
        </span>
      </div>
    </div>
  );
};

export default LessonTopBar;
